import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
  IconButton,
  Chip,
  CircularProgress,
  Box,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  ArrowDropUp as ArrowDropUpIcon,
  AccountCircle,
  ArrowDropDown as ArrowDropDownIcon,
  ExpandMore as ExpandMoreIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import { endpoints } from "../../../services/endpoint";
import { axiosInstance } from "../../../services/axiosInstance";
import CustomHours from "./addCustomhours.js";
import "./addhours.css";

const AddHoursPage = ({
  onClose,
  onHoursAdded,
 
  
  existingHours = [],
}) => {
  const accessurl = localStorage.getItem("selctedurl");

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [timezone, setTimezone] = useState("");
  const [timeZoneList, setTimeZone] = useState([]);
  const [tags, setTags] = useState({});
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [showTags, setShowTags] = useState(false);

  const [customHoursData, setCustomHoursData] = useState({});
  const [existingHourNames, setExistingHourNames] = useState([]);

  const [nameError, setNameError] = useState("");
  const [timezoneError, setTimezoneError] = useState("");
  const [hoursError, setHoursError] = useState("");

  const [loading, setLoading] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);
 const [actionClicked, setActionClicked] = useState(null); 
  // ✅ Load existing names
  useEffect(() => {
    if (existingHours?.length > 0) {
      const names = existingHours.map((hour) => hour.name);
      setExistingHourNames(names);
    }
  }, [existingHours]);

  // ✅ Fetch timezones on mount
  useEffect(() => {
    fetchTimeZones();
  }, []);

  const fetchTimeZones = async () => {
    try {
      const response = await axiosInstance.get(endpoints.addhop.timezoneslist, {
        headers: { "Content-Type": "application/json" },
      });

      if (Array.isArray(response.data)) {
        setTimeZone(response.data);
      } else {
        console.error("Expected an array but got:", response.data);
      }
    } catch (error) {
      console.error("Error fetching timezones:", error);
    }
  };

  const toggleTagsDisplay = () => setShowTags(!showTags);

  const validateName = (value) => {
    const trimmedValue = value.trim();

    if (
      existingHourNames.some(
        (hourName) => hourName.toLowerCase() === trimmedValue.toLowerCase()
      )
    ) {
      setNameError("An hour with this name already exists");
      return false;
    }
    if (!trimmedValue) {
      setNameError("Name is required");
      return false;
    }
    if (trimmedValue.length > 50) {
      setNameError("Hour name must be 50 characters or less");
      return false;
    }
    setNameError("");
    return true;
  };

  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    validateName(newName);
  };

  const handleAddTag = () => {
    if (key && value) {
      setTags((prevTags) => ({
        ...prevTags,
        [key]: value,
      }));
      setKey("");
      setValue("");
    }
  };

  const handleDeleteTag = (tagKeyToDelete) => {
    setTags((prevTags) => {
      const updatedTags = { ...prevTags };
      delete updatedTags[tagKeyToDelete];
      return updatedTags;
    });
  };

  const validateHours = (customHoursData) => {
    const hasTimeSlots = Object.values(customHoursData).some(
      (slots) => slots && slots.length > 0
    );

    if (!hasTimeSlots) {
      setHoursError("At least one time slot must be defined");
      return false;
    }

    for (const day in customHoursData) {
      const slots = customHoursData[day];
      if (slots && slots.length > 0) {
        for (const slot of slots) {
          if (
            slot.startTime &&
            slot.endTime &&
            new Date(slot.startTime) >= new Date(slot.endTime)
          ) {
            setHoursError(`Start time for ${day} must be before end time.`);
            return false;
          }
        }
      }
    }

    setHoursError("");
    return true;
  };

  const validateInputs = () => {
    let isValid = true;
    setNameError("");
    setTimezoneError("");

    if (!name) {
      setNameError("Name is required.");
      isValid = false;
    }
    if (!timezone) {
      setTimezoneError("Timezone is required.");
      isValid = false;
    }

    return isValid;
  };

  const instanceAlias = localStorage.getItem("instanceName");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const username = localStorage.getItem("username");
  const region = localStorage.getItem("Region");
  const instanceId = localStorage.getItem("InstanceId");
  const EncryptedInstanceId=localStorage.getItem("EncryptedId")
  const email = localStorage.getItem("Email");
  // ✅ Fetch updated HOP list after save
  const fetchHoursOfOperation = async () => {
  const payload = {
    InstanceAlias: instanceAlias,
    awsAccount: customerAWSAccountId,
    region,
    ID: EncryptedInstanceId,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.displaylisthop.dipslayhopdata,
      payload
    );

    console.log("API Raw Response:", response.data);

    if (!response.data?.body) {
      console.warn("⚠️ No body in API response");
      return [];
    }

    // ✅ Parse body (it is an ARRAY, not an object)
    const parsedBody =
      typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data.body;

    if (!Array.isArray(parsedBody)) {
      console.warn("⚠️ Body is not an array");
      return [];
    }

    const extractedData = parsedBody.map((item) => {
      const configData = item.Config || [];

      // ✅ Store config using ARN (stable key)
      localStorage.setItem(
        `customHoursConfig_${item.Arn}`,
        JSON.stringify(configData)
      );

      // ✅ Normalize tags
      let tagsArray = [];
      if (item.Tags && typeof item.Tags === "string" && item.Tags !== "-") {
        tagsArray = item.Tags.split(",").map(tagStr => {
          const [key, value] = tagStr.split(":").map(s => s.trim());
          return { key, value };
        });
      }

      return {
        id: item.Arn, // ✅ ARN instead of HOPId
        name: item.Name,
        description: item.Description || "No description",
        tags: tagsArray,
        timeZone: item.TimeZone || "No timezone",
        config: configData,
        lastModifiedTime: item.LastModifiedTime || "No modification time",
      };
    });

    console.log("✅ Extracted Hours Data:", extractedData);
    return extractedData;

  } catch (error) {
    console.error("❌ Error fetching updated hours:", error);
    return [];
  }
};

  // ✅ Handle Save → refresh table without navigating
  const handleSave = async () => {
    if (!validateInputs()) return;

    if (
      customHoursData &&
      Object.values(customHoursData).some((slots) => slots && slots.length > 0)
    ) {
      if (!validateHours(customHoursData)) return;
    }
setActionClicked("save");
    setLoading(true);

    const requestPayload = {
      action: "create",
      name,
      description,
      timezone,
      timeSlots: customHoursData,
      accessurl,
      tags,
      ID:EncryptedInstanceId,
      InstanceAlias: instanceAlias,
      UserName:username,
      Email:email,
      region,
      awsAccount: customerAWSAccountId,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.addhours.addhop,
        requestPayload
      );

      if (response.status === 200) {
        console.log("✅ Hours created successfully:", response.data);

        // ✅ Fetch updated list
        const updatedList = await fetchHoursOfOperation();

        // ✅ Call parent callback to refresh table
        if (typeof onHoursAdded === "function") {
          onHoursAdded(updatedList);
        }
      } else {
        console.error("Unexpected response while saving:", response);
      }
    } catch (error) {
      console.error("Error creating hours:", error);
    } finally {
      setLoading(false);
      setActionClicked(null);
    }
  };

  
  const handleCancel = () => {
    setActionClicked("cancel");
    setCancelButtonLoading(true);

    if (typeof onClose === "function") {
      // Call onClose, if it's synchronous, reset state immediately after
      const result = onClose();
      if (result instanceof Promise) {
        result.finally(() => {
          setActionClicked(null);
          setCancelButtonLoading(false);
        });
      } else {
        setActionClicked(null);
        setCancelButtonLoading(false);
      }
    }
  };
  return (
    <div className="addhour-navbar-container">
      <Container className="addhour-content-container">
        <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
               <IconButton
                 onClick={onClose}
                 size="medium"
                 sx={{
                   border: "1px solid #ccc",       // border color
                   borderRadius: "50%",            // makes it circular
                   padding: 1,                     // inner spacing
                   bgcolor: "#f5f5f5",             // background color
                   "&:hover": { bgcolor: "#e0e0e0" } // hover effect
                 }}
               >
                 <ArrowBackIcon />
               </IconButton>
              {/* Title */}
              <Typography variant="h4" className="phone-text">
                Add Hours of operation
              </Typography>
            </Box>
        {/* Hours of Operation Form */}
        <div className="form-section">
        
          <div className="hour-form-fields">
            <TextField
              label="Name"
             placeholder="Enter Name"
              required
              value={name}
              onChange={handleNameChange}
              onBlur={() => validateName(name)}
              error={Boolean(nameError)}
              helperText={nameError}
            />
            <TextField
              label="Description"
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <TextField
              label="Select time zone"
             placeholder="Slect timezone"
              required
              select
              value={timezone}
              onChange={(e) => setTimezone(e.target.value)}
              error={Boolean(timezoneError)}
              helperText={timezoneError}
            >
              {timeZoneList.length > 0 ? (
                timeZoneList.map((tz, i) => (
                  <MenuItem key={i} value={tz}>
                    {tz}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No time zones available</MenuItem>
              )}
            </TextField>
          </div>
        </div>

        {/* Custom Hours Component */}
        <div className="addhour-setting-section">
          <h3>Settings</h3>
          <CustomHours setCustomHoursData={setCustomHoursData} />
          {hoursError && <span style={{ color: "red" }}>{hoursError}</span>}

          {/* Advanced Settings */}
          <Box className="tags-container">
            <Box className="advancedoption-styling" onClick={toggleTagsDisplay}>
              <Typography>Show advanced settings
              <IconButton>
                {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </IconButton>
              </Typography>
            </Box>

            {showTags && (
              <>
                
               <Box
                        display="flex"
                        gap={1}
                        mt={2}
                      >
                  <TextField
                    label="Key"
                 placeholder="Key"
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                  />
                  <TextField
                    label="Value"
                  placeholder="value"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    disabled={!key}
                  />
                  <Button
                    variant="outlined"
                    onClick={handleAddTag}
                    disabled={!key || !value}
                  >
                    Add
                  </Button>
                </Box>

                {Object.keys(tags).length > 0 && (
                  <Box className="tags-display" mt={2}>
                   <Typography variant="subtitle1" sx={{ textAlign: "left" }}>
  Selected Tags
</Typography>

                    <Box className="tags-list">
                      {Object.entries(tags).map(([tagKey, tagValue], index) => (
                        <Chip
                          key={index}
                          label={`${tagKey}: ${tagValue}`}
                          onDelete={() => handleDeleteTag(tagKey)}
                          size="small"
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Box>
        </div>

        {/* Buttons */}
        <div className="buttons-addhour">
          <Button
            onClick={handleCancel}
           
             disabled={actionClicked === "save" || cancelButtonLoading}
                 >
                   {actionClicked === "cancel" ? <CircularProgress size={18} /> : "Cancel"}
          </Button>
          <Button
            onClick={handleSave}
 
           variant="contained"
           disabled={actionClicked === "cancel" || loading}
               >
                 <span className="adduser-button-content">
                   {actionClicked === "save" ? (
                     <CircularProgress size={18} style={{ color: "white" }} />
                   ) : (
                     "Save"
                   )}
                   </span>
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default AddHoursPage;
